import { FunctionComponent } from 'react';
import styles from './AnchoredCardImage.module.scss';

interface IProps {
  imageUrl: string;
  height?: number;
  style?: any;
}

const AnchoredCardImage: FunctionComponent<IProps> = ({ imageUrl, height = 150, style }) => (
  <div className={styles.base} style={style} data-testid="AnchoredCardImageContainer">
    <div className={styles.cardImg} style={{ height }}>
      <img className={styles.croppedCardImg} src={imageUrl} alt="" />
    </div>
  </div>
);

export default AnchoredCardImage;
